














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Icon, Button, ButtonGroup } from '@alpha/ink'
import Redactor from '@/components/Redactor.vue'

export interface EditorTracker {
  input: string
  save: string
  cancel: string
  revert: string
}

@Component({
  components: {
    Icon,
    Button,
    ButtonGroup,
    Redactor
  }
})

export default class TitleEditor extends Vue {
  @Prop({ required: true }) readonly placeholder!: string
  @Prop({ required: true }) readonly showCounter!: boolean
  @Prop({ required: true }) readonly currentValue!: string
  @Prop({ default: 100 }) readonly limit!: number
  @Prop({ default: {} }) config!: { value?: string | undefined }
  @Prop({ default: () => true }) hasFormatting!: boolean
  @Prop({ required: true }) saving!: boolean
  @Prop({ required: false, default: true }) showRevert!: boolean
  @Prop({
    default: {
      input: 'LabelEditorInput',
      save: 'LabelEditorSave',
      cancel: 'LabelEditorCancel',
      revert: 'LabelEditorRevert'
    }
  }) readonly track?: EditorTracker

  editorValue:string = this.currentValue
  mode:string = this.hasFormatting ? 'sharedReport' : 'sharedReportNoHtml'

  @Watch('currentValue')
  updateEditValue (val: string, oldVal: string) {
    this.editorValue = val
  }

  setContent (value: string) {
    this.$emit('setContent', value)
  }

  keyUp (value: string) {
    this.$emit('keyUp', value)
  }

  saveClick () {
    this.$emit('saveClick')
  }

  cancelClick () {
    this.$emit('cancelClick')
  }

  revertClick () {
    this.$emit('revertClick')
  }

  get count () {
    return `${this.editorValue.length} /${this.limit}`
  }

  get passedLimit () {
    return this.showCounter && this.editorValue.length > this.limit
  }
}
